@let memberDataValue = memberData();
@let activeComponentValue = activeComponent();
@let isSelfValue = isSelf();
@let canManageUsersValue = canManageUsers();

<rt-dialog-header class="no-bottom-padding">
  <div class="header-content">
    @if (memberDataValue) {
      <tlc-edit-member-header
        [avatarThumbUrl]="memberDataValue.avatarThumbUrl"
        [isOwner]="memberDataValue.hasFullAccess ?? false"
        [email]="memberDataValue.firstName || memberDataValue.lastName ? memberDataValue.email : ''"
        [isDeactivated]="memberDataValue.status === TeamMemberStatus.Deactivated"
        [memberGuid]="memberDataValue.guid"
      />
    } @else {
      <div class="member-skeleton-header" layout layout-align-items-center>
        <rt-placeloader class="member-skeleton-avatar" />
        <div class="member-skeleton-header-text" layout-vertical margin-left-small>
          <rt-placeloader variant="text" />
          <rt-placeloader variant="text" [short]="true" />
        </div>
      </div>
    }
    @if (isExternallyManaged()) {
      <rt-infobox
        class="managed-infobox"
        type="information"
        iconName="info-outline"
        [isDismissible]="false"
        [heading]="
          (isOktaManaged()
            ? 'tlc.members.edit_member.managed_infobox.okta.heading'
            : 'tlc.members.edit_member.managed_infobox.scim.heading'
          ) | translate
        "
      >
        <span
          [innerHTML]="
            (isOktaManaged()
              ? 'tlc.members.edit_member.managed_infobox.okta.body'
              : 'tlc.members.edit_member.managed_infobox.scim.body'
            ) | translate
          "
        ></span>
      </rt-infobox>
    }
  </div>

  <rt-tabs padding-left>
    <rt-tab
      (click)="setActiveTab(isSelfValue ? MemberEditTab.EditProfile : MemberEditTab.Account)"
      [class.active]="
        activeComponentValue === MemberEditTab.Account ||
        activeComponentValue === MemberEditTab.EditProfile
      "
    >
      {{ 'tlc.members.edit_member.tabs.account' | translate }}
    </rt-tab>

    @if (canManageUsersValue) {
      <rt-tab
        (click)="setActiveTab(MemberEditTab.PermissionsAccess)"
        [class.active]="activeComponentValue === MemberEditTab.PermissionsAccess"
      >
        {{ 'tlc.members.edit_member.tabs.permissions_and_access' | translate }}
      </rt-tab>
    }

    @if (groupsFlag()) {
      <rt-tab
        (click)="setActiveTab(MemberEditTab.Groups)"
        [class.active]="activeComponentValue === MemberEditTab.Groups"
      >
        {{ 'tlc.members.edit_member.tabs.groups' | translate }}
      </rt-tab>
    }
    @if (departmentsFlag()) {
      <rt-tab
        (click)="setActiveTab(MemberEditTab.Departments)"
        [class.active]="activeComponentValue === MemberEditTab.Departments"
      >
        {{ 'tlc.members.edit_member.tabs.departments' | translate }}
      </rt-tab>
    }
  </rt-tabs>
</rt-dialog-header>
@if (memberData()) {
  <ng-container
    [rtComponentOutlet]="componentMap.get(activeComponentValue)"
    [rtComponentOutletInputs]="memberInputs"
  />
} @else {
  <rt-dialog-body variant="white">
    <div class="member-skeleton-body" layout-vertical>
      <rt-placeloader variant="item" />
      <rt-placeloader variant="item" />
      <rt-placeloader variant="item" />
      <rt-placeloader variant="item" />
    </div>
  </rt-dialog-body>
}
